import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseOrganizationRestrictionRemoved } from 'entities/Organization/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventOrganizationRestrictionRemoved = (onSuccess: () => void) => {
  const { websocket } = useEntitiesContext()
  const handle = async (data: IResponseOrganizationRestrictionRemoved) => {
    if (data.restriction_type) {
      onSuccess()
    }
  }

  useEffect(() => {
    websocket.on(WebsocketEvent.OrganizationRestrictionRemoved, handle)
    return () => websocket.off(WebsocketEvent.OrganizationRestrictionRemoved, handle)
  }, [])
}
